"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var awsui_attribute_editor_1 = require("../attribute-editor/awsui-attribute-editor");
var TagEditorRowWrapper = /** @class */ (function (_super) {
    __extends(TagEditorRowWrapper, _super);
    function TagEditorRowWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagEditorRowWrapper.prototype.findUndoButton = function () {
        return this.find('.awsui-tag-editor-undo-button');
    };
    return TagEditorRowWrapper;
}(awsui_attribute_editor_1.AttributeEditorRowWrapper));
exports.TagEditorRowWrapper = TagEditorRowWrapper;
var TagEditorWrapper = /** @class */ (function (_super) {
    __extends(TagEditorWrapper, _super);
    function TagEditorWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagEditorWrapper.prototype.findRows = function () {
        return this.findAll('.awsui-attribute-editor__row').map(function (i) { return new TagEditorRowWrapper(i.getElement()); });
    };
    return TagEditorWrapper;
}(awsui_attribute_editor_1.default));
exports.default = TagEditorWrapper;
//# sourceMappingURL=awsui-tag-editor.js.map